export default __webpack_public_path__ + "static/media/phoneSocial3.cbd81649.png";